import React from "react";
import { useTheme } from "../ThemeContext";
import { FaSun, FaMoon } from "react-icons/fa";
import { Toggle } from "@cadenza/ui";

const DarkModeToggle = () => {
  const { isDark, setIsDark, colorTheme } = useTheme();

  // Hide toggle when only one color theme is available
  if (colorTheme && colorTheme.includes("only")) {
    return null;
  }

  return (
    <Toggle
      isOn={isDark}
      onToggle={setIsDark}
      onIcon={
        <FaMoon
          className="cs-icon"
          style={{ color: "var(--text-secondary)" }}
        />
      }
      offIcon={
        <FaSun className="cs-icon" style={{ color: "var(--text-secondary)" }} />
      }
      onLabel="Switch to light mode"
      offLabel="Switch to dark mode"
    />
  );
};

export default DarkModeToggle;
